import { PayStubActions } from '@portal/actions';
import * as ActionTypes from '~/actions/actionTypes';

const initialState: reducers.PayStubReducer = {
  error: null,
  list: {
    rows: [],
    count: 0,
  },
  success: null,
  detail: null,
  exportPayStubDownloadUrl: null,
};

export type PayStubActions =
  | PayStubActions.SetPayStubErrorAction
  | PayStubActions.SetPayStubListAction
  | PayStubActions.SetPayStubSuccessAction
  | PayStubActions.SetPayStubDetailAction;

const payStubReducer = (
  state = initialState,
  action: PayStubActions
): reducers.PayStubReducer => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SET_PAY_STUB_LIST:
      if (
        payload instanceof Error ||
        typeof payload === 'string' ||
        payload === null ||
        'details' in payload
      ) {
        return state;
      }

      return {
        ...state,
        list: payload,
      };

    case ActionTypes.SET_PAY_STUB_ERROR:
      if (!(payload instanceof Error) && payload !== null) {
        return state;
      }

      return {
        ...state,
        error: payload,
      };

    case ActionTypes.SET_PAY_STUB_SUCCESS:
      if (typeof payload !== 'string' && payload !== null) {
        return state;
      }

      return {
        ...state,
        success: payload,
      };

    case ActionTypes.USER_EXPORT_DOWNLOAD_PAY_STUB:
      if (typeof payload !== 'string' && payload !== null) {
        return state;
      }

      return {
        ...state,
        exportPayStubDownloadUrl: payload,
      };

    case ActionTypes.SET_PAY_STUB_DETAIL:
      if (
        payload instanceof Error ||
        typeof payload === 'string' ||
        payload === null ||
        !('details' in payload)
      ) {
        return state;
      }

      return {
        ...state,
        detail: payload,
      };

    default:
      return state;
  }
};

export default payStubReducer;
